module.exports = __webpack_public_path__ + "static/media/list.b58f8776.png";